import { CMSSubscriptionInterface, DoceboSubscriptionInterface } from '@app/interfaces/_index';

import { Adapter } from './adapter';
import { LMSSubscription } from '../models/_index';
import { getSubscriptionProductShortcutName } from '@app/utilities/_index';

/**
 * Adapts raw CMS subscription object to a Subscription Model
 * NOTE: The item fields are the default json property names.
 */
export class SubscriptionAdapter implements Adapter<LMSSubscription> {
  /**
   * Adapts raw CMS subscription object to a Subscription Model
   * @param item CMS Subscription Interface response object
   * @returns - LMS Subscription model
   */
  adapt(item: CMSSubscriptionInterface): LMSSubscription {
    let subscription: LMSSubscription;
    if (item) {
      subscription = new LMSSubscription(
        item.id,
        item.acf.code,
        item.acf.name,
        item.acf.description,
        item.acf.slug_name,
        item.acf.slug_name, // NOTE: Toggle dropdown needs to match slug name
        item.acf.icon,
        item.acf.display_order,
        item.acf.shortcut_name,
        item.acf.product,
        [] // TODO: Fix this in CMS. Currently not used. Field doesn't exist yet in CMS
      );
    }
    return subscription;
  }

  /**
   * Adapts raw Docebo subscription object to a Subscription Model
   * NOTE: The item fields are the default json property names, hence the eslint ignore specific property names.
   * @param item Docebo Subscription Interface response object
   * @returns - LMS Subscription model
   */
  adaptFromLMS(item: DoceboSubscriptionInterface): LMSSubscription {
    let subscription: LMSSubscription;

    if (item && item.data) {
      subscription = new LMSSubscription(
        item.data.id,
        item.data.code,
        item.data.name,
        item.data.description,
        item.data.slug_name,
        item.data.slug_name, // NOTE: Toggle dropdown needs to match slug name
        '', // TODO: Need to check slug name to find hard code icon from enum
        0, // TODO: Need to add display order in future.
        getSubscriptionProductShortcutName(item.data.id),
        item.data.name,
        item.data.courses // TODO: Need to adapt to course models in future.
      );
    }
    return subscription;
  }
}
